var map = {
	"./en-au": 16,
	"./en-au.js": 16,
	"./en-ca": 17,
	"./en-ca.js": 17,
	"./en-gb": 18,
	"./en-gb.js": 18,
	"./en-ie": 19,
	"./en-ie.js": 19,
	"./en-il": 20,
	"./en-il.js": 20,
	"./en-in": 21,
	"./en-in.js": 21,
	"./en-nz": 22,
	"./en-nz.js": 22,
	"./en-sg": 23,
	"./en-sg.js": 23
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;



//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en
// module id = 42
// module chunks = 0